import React, { Fragment } from "react";
import "./catalog.css";
import Breadcrumb from "./../../commons/breadcrumb/breadcrumb";
import Button from "./../../commons/button/button";
import ProductRowHeader from "../../components/product-row-header/product-row-header";
import allProducts from "./../../data/all-products/all-products";
import SingleProduct from "../../components/single-product/single-product";

const Catalog = () => {
  return (
    <Fragment>
      <div className="contianer-fluid catalog_page_body">
        <div className="container">
          <Breadcrumb bread2="فروشگاه" />

          {/* <div className="category_buttons_body">
            <span>
              {" "}
              <Button
                boxShadow="0px 0px 13px -3px #636e72"
                background="#a5c926"
                color="white"
                heigh="32px"
                width="110%"
                radius="23px"
              >
                تمامی محصولات
              </Button>
            </span>
            <span>
              <Button
                boxShadow="0px 0px 13px -3px #636e72"
                background="#a5c926"
                color="white"
                heigh="32px"
                width="110%"
                radius="23px"
              >
                گجت های چوبی
              </Button>
            </span>
            <span>
              <Button
                boxShadow="0px 0px 13px -3px #636e72"
                background="#a5c926"
                color="white"
                heigh="32px"
                width="110%"
                radius="23px"
              >
                عروسک ها
              </Button>
            </span>
          </div> */}
          <div className="product_row_header_body">
            <ProductRowHeader Title="محصولات" />
          </div>
          <div className="catalog_body row">
            {allProducts.map((item, index) => (
              <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <SingleProduct
                  Title={item.title}
                  Image={item.image}
                  id={item.id}
                  key={item.id}
                  price={item.price}
                  marginTop="30px"
                  marginBottom="10px"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Catalog;
